import { render, staticRenderFns } from "./ChatButtons.vue?vue&type=template&id=6dcbfbf5&scoped=true"
import script from "./ChatButtons.vue?vue&type=script&lang=js"
export * from "./ChatButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcbfbf5",
  null
  
)

export default component.exports